import { useStore } from '@/lib/store';

export function StepFour() {
  const { formData, setFormData } = useStore();

  return (
    <div className="space-y-6 animate-in">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Contact Settings</h2>
        <p className="text-gray-600">Set up how you'll receive leads from your landing page.</p>
      </div>

      <div className="space-y-4">
        <div>
          <label htmlFor="contactEmail" className="label">
            Contact Email <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            id="contactEmail"
            className="input"
            placeholder="hello@yourbusiness.com"
            value={formData.contactEmail || ''}
            onChange={(e) => setFormData({ contactEmail: e.target.value })}
          />
          <p className="text-sm text-gray-500 mt-1">
            This is where form submissions from your landing page will be sent.
          </p>
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-blue-800">How it works</h3>
            <div className="mt-2 text-sm text-blue-700">
              <ul className="list-disc list-inside space-y-1">
                <li>Your landing page will include a contact form</li>
                <li>When visitors submit the form, you'll receive an email notification</li>
                <li>All leads are also stored in your dashboard for easy tracking</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
